import {
  ISendCampaignErrorResponse,
  ISendCampaignResponse,
  ISendCampaignSuccessResponse,
} from './send-campaign.types';

export const isSendCampaignErrorResponse = (
  response: ISendCampaignResponse,
): response is ISendCampaignErrorResponse => 'error' in response;

export const isSendCampaignSuccessResponse = (
  response: ISendCampaignResponse,
): response is ISendCampaignSuccessResponse => 'success' in response && response.success === true;
